import script from "./product-info.vue?vue&type=script&setup=true&lang=js"
export * from "./product-info.vue?vue&type=script&setup=true&lang=js"

import "./product-info.vue?vue&type=style&index=0&id=4cd36b4c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd36b4c"]])

export default __exports__